import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import "./ourreach.scss";
import { useQuery } from "react-query";
import useWindowDimensions from "../../../hooks/useWindowDimensions";

import { dropdownarrow, loader, ourreachban } from "../../../images";
import { request } from "../../../utils/axios-utils";
import RightArrowButton from "../../../components/RightArrowButton/RightArrowButton";
import companyData from "./companyData.json";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import MetaDecorator from "../../../components/MetaDecorator/MetaDecorator";

const fetchLocationsCategories = () => {
  return request({ url: "/locations/categories", method: "get" });
};

const OurReach = () => {
  const { width } = useWindowDimensions();
  const [ourReachIndex, setOurReachIndex] = useState(null);

  const {
    isLoading: isLocationsCategoriesLoading,
    data: locationCategoriesData,
  } = useQuery("locations-categories", fetchLocationsCategories);

  let {
    isLoading: isCategoryLocationsLoading,
    data: categoryLocationsData,
    refetch: refetchCategoryLocations,
  } = useQuery(
    "category-location",
    async () => {
      return request({ url: `/locations/${ourReachIndex}`, method: "get" });
    },
    {
      enabled: false,
    }
  );
  if (ourReachIndex === '62c06efd838e7c12e3b2c76e') {
    categoryLocationsData = {
      data: {
        data: [
          // {
          //     "_id": "6307a39f1d7fb152e7de703d",
          //     "name": "Raymond Apparel",
          //     "address": "Jekegram, Pokhran Road No.1, Thane- 400606",
          //     "status": 1,
          //     "locationCategory": "62c06efd838e7c12e3b2c76e",
          //     "createdAt": "2022-08-25T16:30:23.640Z",
          //     "updatedAt": "2022-12-19T07:29:27.892Z",
          //     "__v": 0
          // },
          {
              "_id": "6307a3b61d7fb152e7de7041",
              "name": "Pashmina Holdings",
              "address": "J.K. Building, Morarjee Marg, Ballard Estate, Mumbai-400038",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:30:46.565Z",
              "updatedAt": "2022-12-19T07:29:35.227Z",
              "__v": 0
          },
          {
              "_id": "6307a3d81d7fb152e7de7045",
              "name": "Everblue Apparel",
              "address": "New Hind House Narottam Morarjee Marg, Ballard Estate, Mumbai-400001",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:31:20.197Z",
              "updatedAt": "2022-12-19T07:29:40.493Z",
              "__v": 0
          },
          {
              "_id": "6307a40c1d7fb152e7de7052",
              "name": "JK Files & Engineering",
              "address": "New Hind House, Narottam Morarjee Marg, Ballard Estate, Mumbai-400001",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:32:12.936Z",
              "updatedAt": "2022-12-19T07:29:44.373Z",
              "__v": 0
          },
          {
              "_id": "6307a4271d7fb152e7de7056",
              "name": "JK Talabot",
              "address": "New Hind House, Narottam Morarjee Marg, Ballard Estate, Mumbai-400001",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:32:39.378Z",
              "updatedAt": "2022-12-19T07:30:03.930Z",
              "__v": 0
          },
          // {
          //     "_id": "6307a4431d7fb152e7de705f",
          //     "name": "Colorplus Realty",
          //     "address": "Jekegram, Pokhran Road No.1, Thane - 400606",
          //     "status": 1,
          //     "locationCategory": "62c06efd838e7c12e3b2c76e",
          //     "createdAt": "2022-08-25T16:33:07.398Z",
          //     "updatedAt": "2022-12-19T07:30:08.208Z",
          //     "__v": 0
          // },
          {
              "_id": "6307a45c1d7fb152e7de7063",
              "name": "Silver Spark Apparel",
              "address": "New Hind House, Narottam Morarjee Marg, Ballard Estate, Mumbai-400001",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:33:32.260Z",
              "updatedAt": "2022-12-19T07:30:12.308Z",
              "__v": 0
          },
          {
              "_id": "6307a4731d7fb152e7de7067",
              "name": "Celebrations Apparel",
              "address": "Plot No.156 / H. No.2, Village Zadgaon, Ratnagiri- 415612",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:33:55.033Z",
              "updatedAt": "2022-12-19T07:30:17.675Z",
              "__v": 0
          },
          {
              "_id": "6307a4891d7fb152e7de706b",
              "name": "Scissors Engineering Products",
              "address": "New Hind House, Narottam Morarjee Marg, Ballard Estate, Mumbai-400001",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:34:17.088Z",
              "updatedAt": "2022-12-19T07:30:21.929Z",
              "__v": 0
          },
          {
              "_id": "6307a49c1d7fb152e7de706f",
              "name": "Ring Plus Aqua",
              "address": "D-3,4, Sinnar Taluka Audyogik Vasahat Maryadit, Village Musalgoan, Taluka Sinnar, Nasik- 422112",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:34:36.131Z",
              "updatedAt": "2022-12-19T07:30:25.944Z",
              "__v": 0
          },
          {
              "_id": "6307a4b51d7fb152e7de7073",
              "name": "Raymond Woollen Outerwear",
              "address": "New Hind House, Narottam Morarjee Marg, Ballard Estate, Mumbai-400001",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:35:01.274Z",
              "updatedAt": "2022-12-19T07:30:35.102Z",
              "__v": 0
          },
          // {
          //     "_id": "6307a4c91d7fb152e7de7077",
          //     "name": "Raymond Luxury Cottons",
          //     "address": "New Hind House, Narottam Morarjee Marg, Ballard Estate, Mumbai-400001",
          //     "status": 1,
          //     "locationCategory": "62c06efd838e7c12e3b2c76e",
          //     "createdAt": "2022-08-25T16:35:21.771Z",
          //     "updatedAt": "2022-12-19T07:30:46.590Z",
          //     "__v": 0
          // },
          // {
          //     "_id": "6307a4dc1d7fb152e7de707b",
          //     "name": "Raymond Lifestyle",
          //     "address": "C/O Raymond Limited, Jekegram, Pokhran Road No. 1, Thane West, Thane – 400606",
          //     "status": 1,
          //     "locationCategory": "62c06efd838e7c12e3b2c76e",
          //     "createdAt": "2022-08-25T16:35:40.107Z",
          //     "updatedAt": "2022-12-19T07:30:50.687Z",
          //     "__v": 0
          // },
          {
              "_id": "6307a4f11d7fb152e7de707f",
              "name": "TenX Realty",
              "address": "C/O Raymond Limited, Jekegram, Pokhran Road No. 1, Thane West, Thane – 400606",
              "status": 1,
              "locationCategory": "62c06efd838e7c12e3b2c76e",
              "createdAt": "2022-08-25T16:36:01.663Z",
              "updatedAt": "2022-12-19T07:30:54.509Z",
              "__v": 0
          }
      ]
      }
    }
  }

  console.log(categoryLocationsData, 'hhhhh')
  useEffect(() => {
    if (locationCategoriesData) {
      const locationCategoriesArr = locationCategoriesData.data.data;
      if (locationCategoriesArr.length > 0) {
        setOurReachIndex(locationCategoriesArr[0]["_id"]);
      }
    }
  }, [locationCategoriesData]);

  useEffect(() => {
    if (ourReachIndex) {
      refetchCategoryLocations();
    }
  }, [ourReachIndex]);

  const bannerArr = [
    {
      id: 1,
      img: ourreachban,
      firsthead: "Our Company | Our Reach",
      heading: "Our Reach",
      desc: "Raymond’s global footprint includes exports to 55+ countries, stores across different locations and unique experiences.",
    },
  ];

  // const ourReachData = [
  //   {
  //     tabName: "Plants",
  //     list: [
  //       {
  //         name: "JAYKAYORG AG",
  //         address: "2, Quai Ostervald, 2000 Nechatel, Switzerland",
  //       },
  //       {
  //         name: "RAYMOND (EUROPE) LIMITED",
  //         address: "Barratt House, 341-349, Oxford Street, London – WIC2JE",
  //       },
  //       {
  //         name: "R&A LOGISTICS INC.",
  //         address: "27, Mulvaney Street , Asheville, NC 28803, USA",
  //       },
  //       {
  //         name: "RAYMOND LIFESTYLE",
  //         address:
  //           "International Dubai Multi Commodities Centre ”DMCC”, Dubai UAE",
  //       },
  //       {
  //         name: "SILVER SPARK - MIDDLE EAST FZE",
  //         address: "SAIF Zone, Sharjah, UAE",
  //       },
  //       {
  //         name: "SILVER SPARK APPAREL - ETHIOPIA PLC",
  //         address:
  //           "Shade No. 17, 18 and 19, Hawassa Industrial Park, Hawassa, Ethiopia",
  //       },
  //     ],
  //   },
  //   {
  //     tabName: "Dummy",
  //     list: [
  //       {
  //         name: "Dummy",
  //         address: "2, Quai Ostervald, 2000 Nechatel, Switzerland",
  //       },
  //       {
  //         name: "RAYMOND (EUROPE) LIMITED",
  //         address: "Barratt House, 341-349, Oxford Street, London – WIC2JE",
  //       },
  //       {
  //         name: "R&A LOGISTICS INC.",
  //         address: "27, Mulvaney Street , Asheville, NC 28803, USA",
  //       },
  //       {
  //         name: "RAYMOND LIFESTYLE",
  //         address:
  //           "International Dubai Multi Commodities Centre ”DMCC”, Dubai UAE",
  //       },
  //       {
  //         name: "SILVER SPARK - MIDDLE EAST FZE",
  //         address: "SAIF Zone, Sharjah, UAE",
  //       },
  //       // {
  //       //   name: "SILVER SPARK APPAREL - ETHIOPIA PLC",
  //       //   address:
  //       //     "Shade No. 17, 18 and 19, Hawassa Industrial Park, Hawassa, Ethiopia",
  //       // },
  //     ],
  //   },
  // ];

  const bannerList = bannerArr.map((item, i) => (
    <div className="row" key={i}>
      <div className="col-lg-6 flex_box">
        {width > 834 ? (
          <div className="text_container">
            <BreadCrumb linkTwoText={item.firsthead} linkTwoDisabled />
            <div className="heading">{item.heading}</div>
            <div className="desc">{item.desc}</div>
            {/* <div className="store_cta_wrapper">
              <RightArrowButton
                anchorCta
                anchorLink="https://stores.myraymond.com/"
                ctaText="Store Locator"
              />
            </div> */}
          </div>
        ) : null}
      </div>
      <div className="col-lg-6">
        {width <= 834 ? (
          <div className="text_container">
            <BreadCrumb linkTwoText={item.firsthead} linkTwoDisabled />
            <div className="heading">{item.heading}</div>
            <div className="desc">{item.desc}</div>
            <div className="store_cta_wrapper">
              <RightArrowButton
                anchorCta
                anchorLink="https://stores.myraymond.com/"
                ctaText="Store Locator"
              />
            </div>
          </div>
        ) : null}
        <img
          src={item.img}
          alt="raymond Brand img"
          className="mainimg"
          loading="lazy"
          width={807}
          height={539}
        />
      </div>
    </div>
  ));

  const companyList = companyData.map((item, i) => (
    <div className="col-md-6 col-lg-4 our_company" key={i}>
      <div className="flex_box">
        <h4 className="title">{item.title}</h4>
        <RightArrowButton anchorCta anchorLink={item.link} ctaText="Here" />
      </div>
    </div>
  ));
  const ourReachTabList = locationCategoriesData?.data?.data?.map(
    ({ name, _id }) => (
      <option value="Raymond" key={_id} data-reachindexid={_id}>
        {name}
      </option>
    )
  );

  const ourReachDataList = categoryLocationsData?.data?.data?.map(
    ({ name, address, _id }) => (
      <div className={`col-md-6 col-lg-4 our_reach active`} key={_id}>
        <div className="flex_box">
          <h4 className="title">{name}</h4>
          <p className="desc">{address}</p>
        </div>
      </div>
    )
  );

  const handleReachTabChange = (e) => {
    const reachIndexId = e.target.selectedOptions[0].dataset.reachindexid;
    setOurReachIndex(reachIndexId);
  };

  if (isLocationsCategoriesLoading) {
    return <Loader />;
  }
  return (
    <>
      <MetaDecorator metaTitle="Welcome to Raymond | Our Reach" />
      <section className="reach_sec1" data-aos="fade-in">
        <div className="my_container">
          {bannerList}

          <div className="company_wrapper">
            <div className="row">{companyList}</div>
          </div>
        </div>
      </section>

      <section className="reach_sec2" data-aos="fade-in">
        <div className="my_container">
          <div className="dropdown_sec">
            <div className="reach_tabs_dropdown_wrapper">
              <select
                onChange={handleReachTabChange}
                className="reach_dropdown"
              >
                {ourReachTabList}
              </select>

              <img
                src={dropdownarrow}
                alt="raymond dropdown logo"
                className="downdropdownarrow"
              />
            </div>
          </div>
          <div className="our_reach_wrapper row">
            {isCategoryLocationsLoading ? (
              <figure className="locations_data_loader">
                <img src={loader} alt="Loader" />
              </figure>
            ) : (
              ourReachDataList
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurReach;
/*{
 <div
      className={`our_reach row ${ourReachIndex == i ? "active" : ""}`}
      key={i}
    >
      {reachData.list.map(({ name, address }, i) => (
        <div className="col-md-6 col-lg-4 flex_box" key={i}>
          <h4 className="title">{name}</h4>
          <p className="desc">{address}</p>
        </div>
      ))}
    </div> 
}
*/
